export class NativeStreamTransformQuestion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamQuestionType",
            "format": ""
        },
        {
            "name": "instructions",
            "baseName": "instructions",
            "type": "string",
            "format": ""
        },
        {
            "name": "options",
            "baseName": "options",
            "type": "Array<NativeStreamChoiceOption>",
            "format": ""
        },
        {
            "name": "levels",
            "baseName": "levels",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "criteria",
            "baseName": "criteria",
            "type": "NativeStreamYesNoCriteria",
            "format": ""
        },
        {
            "name": "threshold",
            "baseName": "threshold",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformQuestion.attributeTypeMap;
    }
    constructor() {
    }
}
